'use client';
import React from 'react';
import { RecommendedArticles } from '@benzinga/article';

const FreestarAd = React.lazy(() =>
  import('@benzinga/ads').then(module => ({ default: module.FreestarAd })),
);

interface Props {
  trendingArticleId?: number;
}

export const QuizSidebar: React.FC<Props> = ({ trendingArticleId }) => {
  return (
    <>
      <FreestarAd className="w-[300px] mb-2 overflow-hidden" placement="sidebar_1" />
      {trendingArticleId !== undefined && <RecommendedArticles articleId={trendingArticleId} />}
    </>
  );
};
